<template>
  <v-main>
    <Header />

    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-container class="fill-height align-center justify-center my-10">
              <v-card v-if="!loading && status.response.status == 'AUTHORIZED'" style="max-width: 700px; padding: 20px; display:flex; align-items:center; flex-direction: column; gap: 16px" width="100%">
                  <v-icon v-if="status" style="font-size: 60px;" :color="status.response.status == 'AUTHORIZED' ? 'success' : 'red'">{{status.response.status == "AUTHORIZED" ? 'mdi-check-circle' : 'mdi-alert-circle'}}</v-icon>
                  <h3 v-if="status">{{status.message}}</h3>
                  <h4>Recibirá un correo con el detalle del pago.</h4>

                  <div style="width: 100%; height: 5px;">
                    <v-divider></v-divider>
                  </div>

                  <div>
<!--                     <p v-if="status"><span style="color: #6B88B5;">Descripción:</span> {{status.patent.name}}</p> -->
                    <p v-if="status"><span style="color: #6B88B5;">Monto:</span> ${{status.response.amount}}</p>
                    <p v-if="status"><span style="color: #6B88B5;">Fecha:</span> {{formatDate(status.response.transactionDate)}}</p>
                  </div>

                <v-btn @click="$router.push('/')" color="primary">Ir al inicio</v-btn>
              </v-card>

              <v-card v-if="!loading && status.response.status == 'FAILED'" style="max-width: 700px; padding: 20px; display:flex; align-items:center; flex-direction: column; gap: 16px" width="100%">
                  <v-icon style="font-size: 60px;" color="red">mdi-alert-circle</v-icon>
                  <h3>{{msg}}</h3>
                <v-btn @click="$router.push('/')" color="primary">Ir al inicio</v-btn>
              </v-card>
            <v-card v-if="loading" style="max-width: 700px; padding: 20px" width="100%">
                <div class="loader" style="margin: 0 auto"></div>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Header from "@/components/commons/Header";
import { getStatus } from "@/helpers/api/horas_medicas";
import moment from 'moment';
export default {
    components: { Header },
    data () {
        return {
            status: null,
            msg: null,
            loading: true,
            loadingBtn: false,
            token: null
        }
    },
    methods: {
        getStatus() {
            const data = {token_ws: this.$route.query.token}
            getStatus(data).then(res => {
              console.log('____', res);
              
                this.status = res
                this.loading = false
            }).catch(e => {
                console.log(e);
                this.msg = e.response.data.message
                this.loading = false                
            })
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY");
        }
    },
    mounted () {
        this.token = this.$route.query.token;
        
          console.log(1);
        if (this.$route.query.token) {
          console.log(2);
          
          this.getStatus();
        }
        if (this.$route.query.msg) {
          console.log(3);
            this.msg = this.$route.query.msg
            this.loading = false
        }
    },
}
</script>

<style lang="scss" scoped>
.loader {
  width: 15px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: l5 1s infinite linear alternate;
}
@keyframes l5 {
  0% {
    box-shadow: 20px 0 #000, -20px 0 #0002;
    background: #000;
  }
  33% {
    box-shadow: 20px 0 #000, -20px 0 #0002;
    background: #0002;
  }
  66% {
    box-shadow: 20px 0 #0002, -20px 0 #000;
    background: #0002;
  }
  100% {
    box-shadow: 20px 0 #0002, -20px 0 #000;
    background: #000;
  }
}
.pending {
  background-color: #fef9c3;
}
.approved {
  background-color: #dcfce7;
}
.rejected {
  background-color: #fee2e2;
}
.status-badge {
  border-radius: 15px;
  padding: 4px 12px;
  height: fit-content;
}
.error-border >>>.v-input__control {
  border: 1px solid #FFFF!important; /* Ajusta según sea necesario */
}
</style>